import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const reportingAPI = createApi({
  reducerPath: 'reportingAPI',
  baseQuery,
  endpoints: (builder) => ({
    getAllReports: builder.mutation({
      query: ({ status, type, page, limit }) => ({
        url: 'reports/admin',
        method: 'GET',
        params: {
          status,
          type,
          page: page + 1,
          size: limit,
        },
      }),
      transformResponse: (response) => response,
      providesTags: ["Report"],
    }),

    getAllVehicleReports: builder.mutation({
      query: ({ status, page, size }) => ({
        url: 'vehicle/reports',
        method: 'GET',
        params: {
          status,
          page: page + 1,
          size,
        },
      }),
      transformResponse: (response) => response,
      providesTags: ["VehicleReport"],
    }),
    vehicleReportAction: builder.mutation({
      query: ({ reportId, body }) => ({
        url: `vehicle/reports/${reportId}/action`,
        method: 'PATCH',
        body,
      }),
      transformResponse: (response) => response,
      invalidatesTags: ['vehicleReports'],
    }),
    updateReportStatus: builder.mutation({
      query: ({ reportId, body }) => ({
        url: `reports/admin/${reportId}`,
        method: 'PATCH',
        body,
      }),
      transformResponse: (response) => response,
      invalidatesTags: ['vehicleReports'],
    }),
  }),
});

export const { 
    useGetAllReportsMutation,
    useGetAllVehicleReportsMutation,
    useVehicleReportActionMutation, 
    useUpdateReportStatusMutation,
} = reportingAPI;

export default reportingAPI;